/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React from "react";
import "./AdminDSR.css";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { AiOutlineClose } from "react-icons/ai";
import * as XLSX from "xlsx";

const EmployeeDSRTab = ({
  // filters
  dsrFilters,
  setDsrFilters,
  dsrProjects,
  dsrEmployees,
  fetchDsrEmployees,
  fetchDsrProjects,
  fetchEmployeeDsr,
  handleDsrReset,

  // table data
  employeeDsrData,

  // edit modal
  showModal,
  modalType,
  closeModal,
  formData,
  setFormData,
  projects,
  handleUpdateTask,

  // delete modal
  showDeleteModal,
  setShowDeleteModal,
  deleteId,
  setDeleteId,
  deleteProjectName,
  setDeleteProjectName,
  handleDeleteConfirm,
  handleDeleteCancel,

  // open modal
  openModal,
}) => {
  // Converts "6 h 30 m" style strings into "06:30" style strings for export
  const toWorkedHoursFormat = (hoursStr) => {
    if (!hoursStr) return "00:00";
    const hMatch = hoursStr.match(/(\d+)\s*h/);
    const mMatch = hoursStr.match(/(\d+)\s*m/);
    const h = hMatch ? parseInt(hMatch[1], 10) : 0;
    const m = mMatch ? parseInt(mMatch[1], 10) : 0;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  };

  const handleDownloadExcel = () => {
    if (!employeeDsrData || employeeDsrData.length === 0) return;

    const rows = employeeDsrData.map((item) => ({
      Employee: item.employee,
      Project: item.project,
      Task: item.task,
      "Worked Hours": toWorkedHoursFormat(item.hours),
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);
    worksheet["!cols"] = [
      { wch: 15 },
      { wch: 20 },
      { wch: 40 },
      { wch: 15 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Employee DSR");

    const fromDate = dsrFilters.fromDate || "";
    const toDate = dsrFilters.toDate || "";
    const fileName = fromDate && toDate
      ? `Employee_DSR_${fromDate}_to_${toDate}.xlsx`
      : "Employee_DSR.xlsx";

    XLSX.writeFile(workbook, fileName);
  };

  const handleDownloadFullScreen = () => {
    if (!employeeDsrData || employeeDsrData.length === 0) return;

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    const fromDate = dsrFilters.fromDate || "N/A";
    const toDate = dsrFilters.toDate || "N/A";

    const tableRowsHtml = employeeDsrData
      .map(
        (item, index) => `
        <tr>
          <td style="text-align: center; width: 60px;">${index + 1}</td>
          <td style="text-align: center; width: 110px;">${item.date || "-"}</td>
          <td>${item.employee || "-"}</td>
          <td>${item.project || "-"}</td>
          <td>${item.task || "-"}</td>
          <td style="text-align: center; width: 90px;">${item.hours || "-"}</td>
        </tr>
      `
      )
      .join("");

    const htmlContent = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Employee DSR Report</title>
        <style>
          * {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
            font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
          }
          body {
            padding: 10px 16px;
            background-color: #fff;
            color: #333;
          }
          .header-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
            padding-bottom: 6px;
            border-bottom: 2px solid #0066cc;
          }
          .title-section h1 {
            font-size: 18px;
            color: #0066cc;
            margin-bottom: 2px;
          }
          .title-section p {
            font-size: 12px;
            color: #666;
          }
          .actions-bar {
            display: flex;
            align-items: center;
            gap: 8px;
          }
          .density-label {
            font-size: 12px;
            font-weight: 600;
            color: #444;
          }
          .btn {
            padding: 4px 10px;
            font-size: 12px;
            font-weight: 600;
            border-radius: 4px;
            border: 1px solid #ccc;
            cursor: pointer;
            background-color: #f8fafc;
            transition: all 0.2s;
          }
          .btn:hover {
            background-color: #e2e8f0;
          }
          .btn-print {
            background-color: #0066cc;
            color: white;
            border: none;
          }
          .btn-print:hover {
            background-color: #004999;
          }
          .btn-close {
            background-color: #6c757d;
            color: white;
            border: none;
          }
          .btn-close:hover {
            background-color: #5a6268;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 6px;
            font-size: 12px;
          }
          th, td {
            border: 1px solid #dcdcdc;
            padding: 4px 8px;
            text-align: left;
            line-height: 1.25;
          }
          th {
            background-color: #f1f5f9;
            color: #1e293b;
            font-weight: 600;
            text-transform: uppercase;
            font-size: 11px;
            letter-spacing: 0.3px;
          }
          tr:nth-child(even) {
            background-color: #f8fafc;
          }
          tr:hover {
            background-color: #e2e8f0;
          }
          @media print {
            .no-print {
              display: none !important;
            }
            body {
              padding: 0;
            }
            table {
              border: 1px solid #000;
            }
            th, td {
              border: 1px solid #000;
              padding: 3px 6px;
            }
          }
        </style>
        <script>
          function changeDensity(padding, fontSize) {
            const cells = document.querySelectorAll('th, td');
            cells.forEach(c => {
              c.style.padding = padding;
              if (fontSize) c.style.fontSize = fontSize;
            });
          }
        </script>
      </head>
      <body>
        <div class="header-container">
          <div class="title-section">
            <h1>Employee DSR Report</h1>
            <p>Period: <strong>${fromDate}</strong> to <strong>${toDate}</strong> | Total Records: <strong>${employeeDsrData.length}</strong></p>
          </div>
          <div class="actions-bar no-print">
            <span class="density-label">View Density:</span>
            <button class="btn" onclick="changeDensity('2px 5px', '11px')">Ultra Compact (50+ rows)</button>
            <button class="btn" onclick="changeDensity('4px 8px', '12px')">Compact</button>
            <button class="btn" onclick="changeDensity('8px 12px', '13px')">Standard</button>
            <button class="btn btn-print" onclick="window.print()">Print / Save PDF</button>
            <button class="btn btn-close" onclick="window.close()">Close</button>
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th style="text-align: center; width: 50px;">#</th>
              <th style="text-align: center; width: 110px;">Date</th>
              <th>Employee</th>
              <th>Project Name</th>
              <th>Task</th>
              <th style="text-align: center; width: 90px;">Hour</th>
            </tr>
          </thead>
          <tbody>
            ${tableRowsHtml}
          </tbody>
        </table>
      </body>
      </html>
    `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();
  };

  return (
    <>
      <div className="filters-section-AdminDSR">
        <div className="filter-group-AdminDSR">
          <label>From Date</label>
          <input
            type="date"
            className="date-input-AdminDSR"
            value={dsrFilters.fromDate}
            onChange={(e) =>
              setDsrFilters({
                ...dsrFilters,
                fromDate: e.target.value,
                toDate: "",
              })
            }
          />
        </div>

        <div className="filter-group-AdminDSR">
          <label>To Date</label>
          <input
            type="date"
            className="date-input-AdminDSR"
            value={dsrFilters.toDate}
            disabled={!dsrFilters.fromDate}
            min={dsrFilters.fromDate}
            onChange={(e) =>
              setDsrFilters({
                ...dsrFilters,
                toDate: e.target.value,
              })
            }
          />
        </div>

        <div className="filter-group-AdminDSR">
          <label>Select Project</label>
          <select
            className="select-dropdown-AdminDSR"
            value={dsrFilters.projectId}
            onChange={(e) => {
              const projectId = e.target.value;
              setDsrFilters((prev) => ({ ...prev, projectId }));
              fetchDsrEmployees(projectId);
            }}
          >
            <option value="">Select</option>
            {dsrProjects.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-group-AdminDSR">
          <label>Select Employee</label>
          <select
            className="select-dropdown-AdminDSR"
            value={dsrFilters.userId}
            onChange={(e) => {
              const userId = e.target.value;
              setDsrFilters((prev) => ({ ...prev, userId }));
              fetchDsrProjects(userId);
            }}
          >
            <option value="">Select</option>
            {dsrEmployees.map((emp) => (
              <option key={emp.id} value={emp.id}>
                {emp.name}
              </option>
            ))}
          </select>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            className="search-button-AdminDSR"
            onClick={fetchEmployeeDsr}
          >
            Search
          </button>

          <button
            className="cancel-button-AdminDSR"
            onClick={handleDsrReset}
          >
            Reset
          </button>

          <button
            className="search-button-AdminDSR"
            onClick={handleDownloadExcel}
            disabled={!employeeDsrData || employeeDsrData.length === 0}
          >
            Download Excel
          </button>

          <button
            className="search-button-AdminDSR"
            onClick={handleDownloadFullScreen}
            disabled={!employeeDsrData || employeeDsrData.length === 0}
          >
            Download Full Screen
          </button>
        </div>
      </div>

      <div className="table-in-all-emplyee-AdminDSR">
        <table className="table-main-AdminDSR">
          <thead className="thead-main-AdminDSR">
            <tr>
              <th>#</th>
              <th>Date</th>
              <th>Employee</th>
              <th>Project Name</th>
              <th>Task</th>
              <th>Hour</th>
              <th>Edit / Delete</th>
            </tr>
          </thead>
          <tbody className="tbody-main-AdminDSR">
            {employeeDsrData.length > 0 ? (
              employeeDsrData.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.date}</td>
                  <td>{item.employee}</td>
                  <td>{item.project || item.ProjectName || "-"}</td>
                  <td>{item.task}</td>
                  <td>{item.hours}</td>
                  <td className="action-buttons-AdminDSR">
                    <button
                      className="edit-icon-button-AdminDSR"
                      onClick={() => openModal("editDSR", item)}
                    >
                      <FiEdit2 />
                    </button>
                    <button
                      className="delete-icon-button-AdminDSR"
                      onClick={() => {
                        setDeleteId(item.id);
                        setDeleteProjectName("");
                        setShowDeleteModal(true);
                      }}
                    >
                      <FiTrash2 />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7">No record found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showModal && modalType === "editDSR" && (
        <div className="modal-overlay-AdminDSR">
          <div className="modal-content-AdminDSR">
            <div className="modal-header-AdminDSR">
              <h3>Edit DSR</h3>
              <button onClick={closeModal} className="close-button-AdminDSR">
                <AiOutlineClose />
              </button>
            </div>

            <div className="modal-body-AdminDSR">
              <div className="form-row-AdminDSR">
                <div className="form-group-AdminDSR">
                  <label>Date *</label>
                  <input
                    type="date"
                    value={formData.date || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, date: e.target.value })
                    }
                  />
                </div>

                <div className="form-group-AdminDSR">
                  <label>Project *</label>
                  <select
                    value={formData.projectId || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, projectId: e.target.value })
                    }
                  >
                    <option value="">Select</option>
                    {projects.map((p) => (
                      <option key={p.id} value={p.id}>
                        {p.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row-AdminDSR">
                <div className="form-group-AdminDSR">
                  <label>Employee *</label>
                  <input
                    type="text"
                    value={formData.employeeName || ""}
                    readOnly
                  />
                </div>

                <div className="form-group-AdminDSR">
                  <label>Hours *</label>
                  <input
                    type="number"
                    value={formData.hours || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, hours: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="form-row-AdminDSR">
                <div className="form-group-AdminDSR">
                  <label>Minutes *</label>
                  <input
                    type="number"
                    value={formData.minutes || ""}
                    onChange={(e) =>
                      setFormData({ ...formData, minutes: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="form-group-AdminDSR">
                <label>Task Detail *</label>
                <textarea
                  rows="4"
                  value={formData.task || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, task: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="modal-footer-AdminDSR">
              <button
                className="save-button-AdminDSR"
                onClick={handleUpdateTask}
              >
                UPDATE
              </button>
              <button className="cancel-button-AdminDSR" onClick={closeModal}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div className="modal-overlay-AdminDSR">
          <div className="modal-content-delete-AdminDSR">
            <div className="modal-header-AdminDSR">
              <h3>Confirm Delete</h3>
              <button
                onClick={handleDeleteCancel}
                className="close-button-AdminDSR"
              >
                <AiOutlineClose />
              </button>
            </div>

            <div className="modal-body-AdminDSR">
              <p className="delete-confirm-text-AdminDSR">
                Are you sure you want to delete this record?
              </p>
            </div>

            <div className="modal-footer-AdminDSR">
              <button
                className="save-button-AdminDSR"
                onClick={handleDeleteConfirm}
                style={{ backgroundColor: "#dc3545" }}
              >
                Yes, Delete
              </button>

              <button
                className="cancel-button-AdminDSR"
                onClick={handleDeleteCancel}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EmployeeDSRTab;